import React from 'react';
import KickImage from 'Reuseables/KickImage';
import BlogHeader from '../../Organisms/BlogHeader';

import { ISearchResultTagProps } from './SearchResultTag.definitions';

/** CSS import */
import Styles from './SearchResultTag.module.scss';
import Popular from './Components/Organisms/Popular';
import Posts from './Components/Organisms/Posts';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';

const SearchResultTag: React.FC<ISearchResultTagProps> = ({}: ISearchResultTagProps) => {
  const bodyRef = React.useRef<HTMLDivElement>(null);

  const { isDesktopView } = useGetViewType();

  return (
    <div className={Styles['wrapper']}>
      <BlogHeader />
      <div className={Styles['search-result-tag-content']} ref={bodyRef}>
        <div className={Styles['main-content']}>
          <Posts bodyScrollableRef={bodyRef} />
        </div>
        {isDesktopView && (
          <div className={Styles['popular-content']}>
            <Popular />
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchResultTag;
